import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { ALL_LANGUAGES, DEFAULT_LANGUAGE } from './languages';

import en from './locales/en.json';
import da from './locales/da.json';
import de from './locales/de.json';
import hu from './locales/hu.json';
import pl from './locales/pl.json';
import ro from './locales/ro.json';
import bg from './locales/bg.json';
import cs from './locales/cs.json';
import sk from './locales/sk.json';
import sr from './locales/sr.json';
import hr from './locales/hr.json';

const resources = {
  en: { translation: en },
  da: { translation: da },
  de: { translation: de },
  hu: { translation: hu },
  pl: { translation: pl },
  ro: { translation: ro },
  bg: { translation: bg },
  cs: { translation: cs },
  sk: { translation: sk },
  sr: { translation: sr },
  hr: { translation: hr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ALL_LANGUAGES,
    fallbackLng: DEFAULT_LANGUAGE,
    // Match "en-US" -> "en"
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      // Resources are bundled synchronously, so no Suspense boundary is needed.
      useSuspense: false,
    },
    detection: {
      // Prefer an explicit choice, then the browser language.
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'appLanguage',
      caches: ['localStorage'],
    },
    returnEmptyString: false,
  });

export default i18n;
